import { User } from "@supabase/supabase-js";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { AdvisorCredentialsSelect } from "@/components/onboarding/AdvisorCredentialsSelect";

interface ProfessionalInfoSectionProps {
  form: any;
  user: User;
}

export function ProfessionalInfoSection({ form }: ProfessionalInfoSectionProps) {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="border-b pb-2">
        <h4 className="text-lg font-medium">Professional Information</h4>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <FormField
          control={form.control}
          name="professionalDesignations"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Certifications</FormLabel>
              <FormControl>
                <AdvisorCredentialsSelect
                  country={form.watch("country")}
                  value={field.value || []}
                  onChange={field.onChange}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="grid grid-cols-1 gap-4">
        <FormField
          control={form.control}
          name="linkedinProfile"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">LinkedIn Profile</FormLabel>
              <FormControl>
                <Input placeholder="https://www.linkedin.com/in/your-profile" className="w-full" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
